interface SortState {
  column: string | null;
  direction: 'asc' | 'desc';
}

export function initCustomerTableSort(): void {
  const tableWrapper = document.querySelector('.table-wrapper') as HTMLElement;
  if (!tableWrapper) return;

  const tbody = tableWrapper.querySelector('tbody.table-block') as HTMLElement;
  if (!tbody) return;

  const sortableHeaders = tableWrapper.querySelectorAll('.sortable-header');
  if (sortableHeaders.length === 0) return;

  const currentSort: SortState = { column: null, direction: 'asc' };

  sortableHeaders.forEach((header) => {
    header.addEventListener('click', (event) => {
      const target = event.currentTarget as HTMLElement;
      const column = target.dataset.sortColumn;
      const sortType = target.dataset.sortType || 'string';

      if (!column) return;

      if (currentSort.column === column) {
        currentSort.direction = currentSort.direction === 'asc' ? 'desc' : 'asc';
      } else {
        currentSort.column = column;
        currentSort.direction = 'asc';
      }

      updateHeaderIndicators(sortableHeaders, target, currentSort.direction);
      sortTable(tbody, column, sortType, currentSort.direction);
    });
  });
}

function updateHeaderIndicators(
  headers: NodeListOf<Element>,
  activeHeader: HTMLElement,
  direction: string
): void {
  headers.forEach((header) => {
    header.classList.remove('asc', 'desc');
  });

  activeHeader.classList.add(direction);
}

function sortTable(
  tbody: HTMLElement,
  column: string,
  sortType: string,
  direction: string
): void {
  const rows = Array.from(tbody.querySelectorAll('tr.customer-row')) as HTMLElement[];

  rows.sort((a, b) => {
    const aCell = a.querySelector(`td[data-column="${column}"]`) as HTMLElement | null;
    const bCell = b.querySelector(`td[data-column="${column}"]`) as HTMLElement | null;

    const aValue: string = aCell?.dataset.sortValue ?? '';
    const bValue: string = bCell?.dataset.sortValue ?? '';

    const aEmpty = aValue === '' || aValue === null || aValue === undefined;
    const bEmpty = bValue === '' || bValue === null || bValue === undefined;

    // Handle empty values - always sort to the end regardless of direction
    if (aEmpty && bEmpty) return 0;
    if (aEmpty) return 1;
    if (bEmpty) return -1;

    let comparison = 0;

    switch (sortType) {
      case 'number':
        comparison = parseFloat(aValue) - parseFloat(bValue);
        break;
      case 'date':
        const dateA = new Date(aValue);
        const dateB = new Date(bValue);
        comparison = dateA.getTime() - dateB.getTime();
        break;
      case 'string':
      default:
        comparison = aValue.localeCompare(bValue);
        break;
    }

    return direction === 'asc' ? comparison : -comparison;
  });

  rows.forEach((row) => tbody.appendChild(row));
}

document.addEventListener('DOMContentLoaded', initCustomerTableSort);
document.addEventListener('turbo:load', initCustomerTableSort);
